<template>
  <div id="app">
    <navBar></navBar>
    <notification></notification>
    <router-view />
  </div>
</template>
<script>
import navBar from './components/navBar/navBar.vue'
import notification from './components/Notifications/notification.vue'
export default {
	name: 'App',
	data() {
		return {
		}
  },
  components: {navBar, notification}
	}
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
#app .h-100 {
    min-height: 100vh !important;
}
</style>
